export const USER_ROLES = {
  admin: "admin",
  user: "user",
  api_user: "api_user",
  college: "college",
  dataminer: "dataminer",
};
